import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from "react-helmet"

const setTags = () => {
  return (
    <Helmet>
      <meta property="fb:app_id" content="158551348225083" />
      <meta property="og:type" content="article" />
      <title itemProp="name" lang="en">404 - Página no encontrada</title>
      <meta property="og:title" content="404 - Página no encontrada" />
      <meta name="description" content="404 - Página no encontrada" />
      <meta property="og:description" content="404 - Página no encontrada" />
      <meta property="og:image" content='http://api.mapcusco.pe/wp-content/uploads/2017/11/map-fb.png' />
    </Helmet>
  )
}

const NotFound = () => {
  const backgroundImage = {
    backgroundImage: 'url(http://api.mapcusco.pe/wp-content/uploads/2017/11/sur-pieza2.jpg)'
  }

  return(
    <div>
      {setTags()}  
      <section className="hero is-fullheight fullscreen-center-xy not-found" style={backgroundImage}>
        <div className="hero-body">
          <div className="column is-10-tablet is-offset-1-tablet is-6-desktop is-offset-3-desktop is-8-widescreen is-offset-2-widescreen is-6-fullhd is-offset-3-fullhd content-info">
            <div className="inner-content">

              <h3>Pagina no encontrada</h3>
              <Link to="/" className="btn-dark">Ir a Inicio</Link>

            </div>
          </div>
        </div>
      </section>
    </div>
  )
} 

export default NotFound;
